module.exports = __webpack_public_path__ + "static/media/comment-exclamation.8dfe0b9e.svg";